"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const isServer = typeof window === 'undefined';
function withSideEffect() {
    const mountedInstances = new Set();
    let state;
    function emitChange(component) {
        state = component.props.reduceComponentsToState([...mountedInstances]);
        if (component.props.handleStateChange) {
            component.props.handleStateChange(state);
        }
    }
    class SideEffect extends react_1.Component {
        // Used when server rendering
        static rewind() {
            const recordedState = state;
            state = undefined;
            mountedInstances.clear();
            return recordedState;
        }
        constructor(props) {
            super(props);
            if (isServer) {
                mountedInstances.add(this);
                emitChange(this);
            }
        }
        componentDidMount() {
            mountedInstances.add(this);
            emitChange(this);
        }
        componentDidUpdate() {
            emitChange(this);
        }
        componentWillUnmount() {
            mountedInstances.delete(this);
            emitChange(this);
        }
        render() {
            return null;
        }
    }
    return SideEffect;
}
exports.default = withSideEffect;
